import React, { useEffect } from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";

export const DeleteDocumentErrorDialog = (props) => {

    const {deleteDocumentError, setDeleteDocumentError} = props

    useEffect(() => {
        let timeoutId;
        if (deleteDocumentError) {
            timeoutId = setTimeout(() => {
                setDeleteDocumentError(false)
            }, 2000);
        }
        return () => {
            clearTimeout(timeoutId)

        };
    }, [deleteDocumentError,setDeleteDocumentError]);

    return (
        <dialog
            className="dialog--temporary"
            open={deleteDocumentError}
            onClose={()=>setDeleteDocumentError(false)}
        >
            <div className="dialog__row-container">
                <header>
                    <h2>
                    Erro ao remover documento
                    </h2>
                </header>
                <IconButton 
                    onClick={()=>setDeleteDocumentError(false)}
                >
                    <CloseIcon />
                </IconButton>
            </div>
        </dialog>
    );
}